import { FC } from 'react'
import { Variants, motion } from 'framer-motion'

export const Logo: FC = ({ className }: { className?: string }) => {
  const pathVar: Variants = {
    initial: {
      pathLength: 0,
    },
    animate: {
      pathLength: 1,
      transition: {
        duration: 2,
      },
    },
    hover: {
      pathLength: [0, 1], // hovered 상태에 따라 애니메이션 변경
      transition: {
        repeat: 0,
        duration: 1.5,
      },
    },
  }
  const svgVar: Variants = {
    initial: {},
    animate: {
      transition: {
        repeat: 0,
        duration: 1,
      },
    },
    hover: {
      scale: 1.2,
      transition: {
        repeat: 0,
        duration: 1,
      },
    },
  }
  return (
    <motion.svg
      className={className}
      variants={svgVar}
      width="104"
      height="31"
      viewBox="0 0 104 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial="initial"
      animate="animate"
      whileHover="hover"
      style={{
        transformOrigin: 'left',
      }}
    >
      <g clipPath="url(#clip0_1998_2035)">
        <motion.path
          variants={pathVar}
          d="M2.83873 5.4997C2.92692 5.00256 3.36364 4.64062 3.87176 4.64062H9.51983C12.936 4.64062 14.9894 6.80391 14.454 9.82003C13.9081 12.8819 11.0757 15.091 7.66163 15.091H4.43237L3.66809 19.3822C3.45603 20.5761 2.4104 21.4456 1.1863 21.4456H0L2.83873 5.4997ZM7.71202 12.1892C9.31406 12.1892 10.704 11.1762 10.9455 9.81795C11.1786 8.50542 10.1707 7.5153 8.56658 7.5153H5.77824L4.94678 12.1872H7.71202V12.1892Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M30.3355 18.1778H29.546L29.7308 17.1419C28.5298 18.0176 27.0915 18.5231 25.628 18.5231C22.2119 18.5231 19.9632 15.7608 20.5763 12.3078C21.1915 8.85488 24.4249 6.09253 27.839 6.09253C29.3024 6.09253 30.5601 6.59799 31.4504 7.4737L31.4819 7.2969C31.5701 6.79976 32.0068 6.43782 32.5149 6.43782H34.539L32.8173 16.1144C32.6052 17.3083 31.5596 18.1778 30.3355 18.1778ZM26.5225 15.715C28.3576 15.715 30.0835 14.2423 30.4279 12.3078C30.7722 10.3754 29.5712 8.90064 27.734 8.90064C25.8968 8.90064 24.1499 10.3733 23.8055 12.3078C23.4612 14.2423 24.6622 15.715 26.5225 15.715Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M37.3021 6.44001H39.2799L39.133 7.26788C39.9917 6.48577 41.2095 6.04688 42.5554 6.04688C45.3206 6.04688 46.9038 7.98135 46.4083 10.7666L45.0897 18.1779H42.0221L43.2504 11.272C43.496 9.89087 42.7507 8.85499 41.4279 8.85499C40.1051 8.85499 38.8726 9.89087 38.6437 11.1805L37.7661 16.1145C37.554 17.3084 36.5084 18.1779 35.2843 18.1779H34.3311L36.2669 7.29908C36.3551 6.80194 36.7918 6.44001 37.3 6.44001H37.3021Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M55.7119 18.1779H55.2143C55.0757 18.1779 54.9707 18.0531 54.9938 17.9179L56.1759 11.272C56.4216 9.89087 55.6531 8.85499 54.3282 8.85499C53.0034 8.85499 51.7751 9.89087 51.5441 11.1805L50.6979 15.9314C50.467 17.2294 49.3269 18.1779 47.9957 18.1779H47.4981C47.3595 18.1779 47.2545 18.0531 47.2776 17.9179L49.1358 7.48213C49.2429 6.87891 49.772 6.44001 50.3893 6.44001H51.9115C52.0501 6.44001 52.1551 6.56482 52.132 6.70002C52.0984 6.89139 52.3126 7.03283 52.4763 6.92259C53.3036 6.35889 54.3408 6.04896 55.4558 6.04896C56.9066 6.04896 58.0215 6.56898 58.6955 7.47589C58.7711 7.5799 58.9223 7.59654 59.0189 7.50917C60.0351 6.5981 61.5217 6.04688 63.0544 6.04688C65.8889 6.04688 67.5015 7.95847 67.006 10.7416L65.6832 18.1758H62.8822C62.7437 18.1758 62.6387 18.051 62.6618 17.9158L63.8313 11.3407C64.0937 9.86799 63.3442 8.85499 61.9962 8.85499C60.6482 8.85499 59.4934 9.86799 59.254 11.2034L58.4121 15.9314C58.1811 17.2294 57.041 18.1779 55.7098 18.1779H55.7119Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M77.9263 18.1778H77.1368L77.3216 17.1419C76.1206 18.0176 74.6823 18.5231 73.2189 18.5231C69.8027 18.5231 67.554 15.7608 68.1671 12.3078C68.7823 8.85488 72.0158 6.09253 75.4298 6.09253C76.8933 6.09253 78.151 6.59799 79.0412 7.4737L79.0727 7.2969C79.1609 6.79976 79.5976 6.43782 80.1057 6.43782H82.1298L80.4081 16.1144C80.196 17.3083 79.1504 18.1778 77.9263 18.1778ZM74.1133 15.715C75.9484 15.715 77.6743 14.2423 78.0187 12.3078C78.363 10.3754 77.162 8.90064 75.3248 8.90064C73.4876 8.90064 71.7407 10.3733 71.3964 12.3078C71.052 14.2423 72.253 15.715 74.1133 15.715Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M101.961 16.1934C99.234 18.8954 95.2887 19.093 92.6684 16.676C90.0627 14.2756 90.0081 10.4565 92.5382 7.95003C95.0032 5.50801 98.7511 5.53922 101.321 7.90635C101.577 8.1414 101.884 8.45549 102.174 8.78622L95.8493 15.0514C97.1175 15.8127 98.6377 15.6089 99.8849 14.3733C100.739 13.5267 101.023 12.6261 100.882 11.3343L103.935 10.8497C104.221 12.7467 103.521 14.6458 101.959 16.1913L101.961 16.1934ZM98.1191 9.38737C97 8.60734 95.5806 8.74462 94.5119 9.80338C93.4431 10.8621 93.4347 12.2038 94.1255 13.3437L98.117 9.38945L98.1191 9.38737Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M83.8623 8.93604C84.5581 8.93604 85.1221 8.37727 85.1221 7.68799C85.1221 6.99871 84.5581 6.43994 83.8623 6.43994C83.1666 6.43994 82.6025 6.99871 82.6025 7.68799C82.6025 8.37727 83.1666 8.93604 83.8623 8.93604Z"
          fill="#FFC955"
        />
        <motion.path
          variants={pathVar}
          d="M88.6764 6.43985L89.2706 3.10132H86.203L85.6256 6.34209L84.9726 10.0072L83.5176 18.1778H84.4708C85.6928 18.1778 86.7405 17.3083 86.9526 16.1143L88.204 9.08572H88.7394C89.9614 9.08572 91.0091 8.21624 91.2212 7.02227L91.3262 6.43777H88.6764V6.43985Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M20.1465 0H19.0106C18.5004 0 18.0573 0.361934 17.9607 0.859074L17.8516 1.4103H20.9192L20.9926 1.04004C21.106 0.465938 20.7281 0 20.1486 0L20.1465 0Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M17.7696 1.82642L15.1514 15.1181H18.1854C18.2295 14.9975 18.2673 14.8727 18.2924 14.7416L20.8351 1.82642H17.7675H17.7696ZM16.1613 14.2549L18.494 2.413H18.704L16.3713 14.2549H16.1613ZM17.5492 14.2549H17.3392L19.6719 2.413H19.8819L17.5492 14.2549Z"
          fill="#10D178"
        />
        <motion.path
          variants={pathVar}
          d="M17.0323 16.8405L18.1661 15.3865H15.1006L15.6612 16.8405H17.0323Z"
          fill="#0FD569"
        />
        <motion.path variants={pathVar} d="M15.7344 17.0317L16.1144 18.0177L16.8829 17.0317H15.7344Z" fill="#10D178" />
        <motion.path
          variants={pathVar}
          d="M50.9237 21.5621C46.354 29.8044 34.4002 31.9403 25.5922 28.6394C20.9785 26.8919 16.3647 23.0086 16.499 17.9312"
          stroke="#10D178"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <motion.path
          variants={pathVar}
          d="M48.5547 19.3843C48.5547 19.3843 49.6465 23.0723 54.4589 21.2917"
          stroke="#10D178"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1998_2035">
          <rect width="104" height="30.8414" fill="white" />
        </clipPath>
      </defs>
    </motion.svg>
  )
}
